// See
//  - <https://github.com/vercel/next.js/issues/58242#issuecomment-1999577070>
//  - <https://github.com/vercel/next.js/pull/64725#pullrequestreview-2024729548>
// eslint-disable-next-line
import "core-js/features/array/to-sorted";
